<template>
  <div
    class="operate-box"
    @click="handleToggleChoose"
  >
    <div
      ref="sortBar"
      class="sort-bar border-bottom-1px"
    >
      <span
        class="sort-set"
      >
        <svg
          class="icon svg-icon"
          aria-hidden="true"
        >
          <use
            v-if="tableSort.sorttype === 1"
            xlink:href="#icon35"
          />
          <use
            v-else-if="tableSort.sorttype === 2"
            xlink:href="#icon34"
          />
          <use
            v-else
            xlink:href="#iconxulie"
          />
        </svg>
        <!-- <i :class="['iconxulie iconfont', {'ascend icon35': tableSort.sorttype === 1, 'descend icon34': tableSort.sorttype === 2 }]" /> -->
        {{ sortName }}
        <i class="iconfont iconicon-test17" />
      </span>
      <span
        class="filter-set"
        @click="toggleFilter"
      >
        <i class="iconfont iconicon-test21" />{{ $t('message["960"]') }}
      </span>
    </div>
    <transition name="slide-up">
      <div
        v-show="sortVisible"
        ref="chooseList"
        class="choose-list"
      >
        <cell-list
          :data="sortOptions"
          :mask="true"
          @change="handleChangeChoose"
        >
          <template v-slot:item="{ data }">
            <div
              class="item"
              :class="{ 'checked': data.checked }"
            >
              <span class="name textOverflow">{{ data.title }}</span>
              <span
                v-if="data.checked"
                class="right"
              >
                <span class="text">{{ tableSort.sorttype === 1 ? sortTit[0] : tableSort.sorttype === 2 ? sortTit[1] : '' }}</span>
                <svg
                  class="icon svg-icon"
                  aria-hidden="true"
                >
                  <use
                    v-if="tableSort.sorttype === 1"
                    xlink:href="#icon35"
                  />
                  <use
                    v-else-if="tableSort.sorttype === 2"
                    xlink:href="#icon34"
                  />
                  <use
                    v-else
                    xlink:href="#iconxulie"
                  />
                </svg>
                <!-- <span>
                <i :class="[{'fs-blue': tableSort.sorttype === 1}]">1</i>
                <i :class="[{'fs-blue': tableSort.sorttype === 2}]">2</i>
              </span> -->
                <!-- <i :class="['iconxulie iconfont', {'ascend icon35': tableSort.sorttype === 1, 'descend icon34': tableSort.sorttype === 2 }]" /> -->
              </span>
            </div>
          </template>
        </cell-list>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import CellList from '@/components/mobile/CellList'
import { clickoutside } from '@/lib/directives'

export default {
  directives: { clickoutside },
  components: {
    CellList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sortVisible: false
    }
  },
  computed: {
    ...mapState('inquery/filterData', ['filterStr']),
    ...mapState('inquery/listData', [
      'pagination',
      'tableSort'
    ]),
    ...mapGetters('inquery/listData', [
      'columnsData'
    ]),
    sortOptions () {
      let { columns = {} } = this.columnsData
      let arr = columns.filter(item => item.sortkey)
      arr.forEach(ele => {
        ele.checked = false
        if (ele.sortkey === this.tableSort.sortkey) {
          ele.checked = true
          ele.sortOrder = this.tableSort.sorttype
        }
      })
      return arr
    },
    sortName () {
      let filter = this.sortOptions.filter(item => item.checked)
      if (!filter.length) return this.$t('message["35"]')

      return filter[0] && filter[0].title
    },
    sortTit () {
      return this.$t('message["1577"]').split('|')
    }
  },
  /* watch: {
    visible (val) {
      console.log(val)
      this.show = val
    }
  }, */
  created () {
    // this.setDefault()

    document.addEventListener('click', this.documentHandler)
  },
  methods: {
    ...mapMutations('inquery/listData', ['SET_TABLE_SORT']),
    handleToggleChoose (e) {
      if (!this.sortOptions.length) return
      if (this.$refs.chooseList.contains(e.target)) return
      if (e.target.className === 'filter-set') return

      let timer = null
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.sortVisible = !this.sortVisible
      }, 300)

      // this.setDefault()
    },
    /* setDefault () {
      this.options.forEach(item => {
        if (item.key === this.activeKey) {
          this.activeName = item.name
          this.$set(item, 'checked', true)
        }
      })
    }, */
    documentHandler (e) {
      let el = this.$refs.sortBar
      if (el && el.contains(e.target)) {
        return false
      }
      this.sortVisible = false
    },
    toggleFilter (val) {
      this.$bus.$emit('showFilter', true)
    },
    handleChangeChoose (item, index) {
      this.sortOptions.forEach(item => {
        this.$set(item, 'checked', false)
      })
      this.$set(item, 'checked', true)

      let sort = item.sortOrder || 0
      sort++
      if (sort >= 3) {
        sort = 0
      }

      let tableSort = {}
      if (sort) {
        item.sortOrder = sort

        tableSort = {
          sortkey: item.sortkey,
          sorttype: sort,
          sortfieldtype: item.fieldtype
        }
      }
      this.SET_TABLE_SORT({ tableSort, sorter: item })

      this.sortVisible = false

      this.$router.push({
        query: {
          ...this.$route.query,
          page: 1,
          limit: this.pagination.pageSize,
          ...tableSort,
          _t: new Date().getTime()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-bar {
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: 48px;
  padding: 12px 16px;
  color: #888;
  background-color: #fff;
  box-shadow: 0px 0px 0px 0px rgba(235,235,235,1);
  overflow: hidden;
  & > span {
    height: 24px;
    line-height: 24px;
  }
}
.choose-list {
  position: fixed;
  top: 94px;
  left: 0;
  z-index: 99;
  width: 100%;
  // background-color: #fff;
  // box-shadow: 0px 0px 0px 0px rgba(235,235,235,1);
  .cell-list {
    height: calc(100vh - 94px);
    .item {
      padding: 0 16px;
    }
  }
  .item.checked {
    .name {
      width: 60%;
      color: $primary-color;
    }
    .right {
      color: #888;
    }
    .text, .icon {
      vertical-align: middle;
    }
  }
}
.operate-box {
  .iconxulie {
    color: #888;
  }
  /* .arrow {
    position: relative;
    top: 4px;
    display: inline-block;
    width: 16px;
    height: 16px;
    &::before {
      content: '';
      position: absolute;
      top: -7px;
      left: 2px;
      width: 0px;
      height: 0px;
      border-width: 6px 5px;
      border-style: solid;
      border-color: transparent transparent #D6D6D6 transparent;
    }
    &::after {
      content: '';
      position: absolute;
      top: 7px;
      left: 2px;
      width: 0px;
      height: 0px;
      border-width: 6px 5px;
      border-style: solid dashed dashed dashed;
      border-color: #D6D6D6 transparent transparent transparent;
    }
    &.ascend::before{
      border-color: transparent transparent #5077AA transparent;
    }
    &.descend::after {
      border-color: #5077AA transparent transparent transparent;
    }
  } */
}

.cube-btn {
  width: 48%;
}
.slide-up-enter,
.slide-up-leave-active {
  -webkit-transform: translate3d(0, -200%, 0);
  transform: translate3d(0, -200%, 0);
}

.slide-up-enter-active,
.slide-up-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>
